import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import useChapterActionIdMatch from "../../../hooks/useChapterActionIdMatch";

import SearchBlockRHF from "../../GeneralComponents/searchBlockRHF/SearchBlockRHF";
import ToolBlock from "../../AdministrativeProcedures/commonComponents/ToolBlock/ToolBlock";
import TableComponent from "../../GeneralComponents/SearchTable/tableComponent";
import AddExaminationResultModal from "../addExaminationResult/addExaminationResultModal";

import {
  getDataInspectionTechnicalConditionBasesAll,
  getDataInspectionTechnicalConditionBasesPagination,
  setDataForTableConditionBases,
} from "../../../redux/inspectionTechnicalConditionBasesReducer/actionsInspectionTechnicalConditionBases";

import { SEARCH_INSPECTION_TECHNICAL_CONDITION_BASES_COLUMNS } from "../../GeneralComponents/SearchTable/TablesColumns";

import {
  options,
  setOptionsForInputsNsiStatusRHF,
  setOptionsSections,
} from "../../../components/GeneralComponents/searchBlockRHF/optionsSearchBlockRHF";

import styles from "./inspectionTechnicalConditionBases.module.css";

export default function InspectionTechnicalConditionBases() {
  const dispatch = useDispatch();
  const location = useLocation();

  const [isShowModal, setIsShowModal] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [selectedPage, setSelectedPage] = useState(0);
  const [searchParams, setSearchParams] = useState({
    ownerLeName: "",
    location: "",
    results: 0,
    startDate: "",
    endDate: "",
    section: null,
    checkStatus: 0,
  });

  const dataForTableConditionBases = useSelector((state) => {
    const { inspectionTechnicalConditionBasesReducer } = state;
    return inspectionTechnicalConditionBasesReducer.paginationData;
  });

  const sortedMenuNames = useSelector((state) => {
    const { roleControllerReducer } = state;
    return roleControllerReducer.sortedMenuNames;
  });
  const addAccess = useChapterActionIdMatch(
    sortedMenuNames?.BOAT_PARKING_CHECKS?.addExaminationResult?.chapterActionId,
  );
  const viewAccess = useChapterActionIdMatch(
    sortedMenuNames?.BOAT_PARKING_CHECKS?.viewTheExaminationResult
      ?.chapterActionId,
  );
  const dictionaryReducer = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer;
  });

  const handleSaveModal = () => {
    handleClear();
  };

  const handleShowModal = () => {
    setIsShowModal(!isShowModal);
  };
  const handleClear = () => {
    setSelectedPage(0);
    setSelectedRowData(null);
    setSearchParams(
      structuredClone({
        ownerLeName: "",
        location: "",
        results: 0,
        startDate: "",
        endDate: "",
        section: null,
        checkStatus: 0,
      }),
    );
    dispatch(
      getDataInspectionTechnicalConditionBasesPagination(
        {
          ownerLeName: "",
          location: "",
          results: 0,
          startDate: "",
          endDate: "",
          section: null,
          checkStatus: 0,
        },
        0,
      ),
    );
  };

  const handleChange = (e) => {
    if (e.target) {
      setSearchParams({
        ...searchParams,
        [e.target.dataset.id]: e.target.value,
      });
    } else {
      setSearchParams({ ...searchParams, [e.key]: e.value });
    }
  };

  const handleSearch = () => {
    setSelectedPage(0);
    setSelectedRowData(null);
    dispatch(
      getDataInspectionTechnicalConditionBasesPagination(searchParams, 0),
    );
  };

  const handleRowSelect = (rowData) => {
    setSelectedRowData(rowData);
    dispatch(setDataForTableConditionBases(rowData));
  };

  const fetchPageData = (pageIndex) => {
    setSelectedPage(pageIndex);
  };

  useMemo(() => {
    setSelectedRowData(null);
    dispatch(
      getDataInspectionTechnicalConditionBasesPagination(
        searchParams,
        selectedPage,
      ),
    );
  }, [selectedPage]);

  // useEffect(() => {
  //   if (dataForTableConditionBases) {
  //     const sortedArray = dataForTableConditionBases.content
  //       .filter((obj) => obj.checkDate !== null)
  //       .map((obj) => {
  //         const parts = obj.checkDate.split("-");
  //         const newDateString = parts[2] + "." + parts[1] + "." + parts[0];
  //         return { ...obj, checkDate: newDateString };
  //       });
  //
  //     setSortedData({ ...dataForTableConditionBases, content: sortedArray });
  //   } else {
  //     setSortedData([]);
  //   }
  // }, [dataForTableConditionBases]);

  useEffect(() => {
    if (dictionaryReducer.gimsSections.length > 0) {
      setOptionsSections(
        dictionaryReducer.gimsSections,
        options.inputsInspectionTechnicalConditionBases.key,
      );
    }
    if (dictionaryReducer.newNsiCheckStatus.length > 0) {
      setOptionsForInputsNsiStatusRHF(
        dictionaryReducer.newNsiCheckStatus,
        options.inputsInspectionTechnicalConditionBases.key,
      );
    }
  }, [dictionaryReducer]);

  useEffect(() => {
    if (dictionaryReducer.gimsSections.length > 0) {
      setOptionsSections(
        dictionaryReducer.gimsSections,
        options.inputsInspectionTechnicalConditionBases.key,
      );
    }
    if (dictionaryReducer.newNsiCheckStatus.length > 0) {
      setOptionsForInputsNsiStatusRHF(
        dictionaryReducer.newNsiCheckStatus,
        options.inputsInspectionTechnicalConditionBases.key,
      );
    }
  }, []);

  useEffect(() => {
    dispatch(getDataInspectionTechnicalConditionBasesAll(searchParams));
    fetchPageData(0);
  }, []);

  return (
    <div className={styles["content-container"]}>
      <SearchBlockRHF
        options={options.inputsInspectionTechnicalConditionBases}
        handleChange={handleChange}
        handleSearch={handleSearch}
        handleClear={handleClear}
        searchParams={searchParams}
        externalStyles={styles}
      />
      <ToolBlock
        addBtnDis={true}
        id={selectedRowData?.parkId}
        setShow={handleShowModal}
        viewAccess={viewAccess}
        addAccess={addAccess}
      />
      <TableComponent
        fetchData={fetchPageData}
        onRowSelect={handleRowSelect}
        columns={SEARCH_INSPECTION_TECHNICAL_CONDITION_BASES_COLUMNS}
        data={dataForTableConditionBases.content || []}
        totalPages={dataForTableConditionBases.totalPages || 0}
        totalElements={dataForTableConditionBases.totalElements || 0}
        selectedPage={selectedPage}
      />
      {isShowModal && (
        <AddExaminationResultModal
          setShow={setIsShowModal}
          show={isShowModal}
          type={location.state?.mode}
          setSave={handleSaveModal}
        />
      )}
    </div>
  );
}
